---
id: go-shared-documentbuilder
title: Shared document builder
owner: Backend Team
status: Active
lastReviewed: 2026-01-30
visibility: internal
tags:
  - documentation
  - openapi
  - shared
---

## Product Overview

### Who it serves

This shared package generates OpenAPI specifications for Go microservices based on their declared route trees.

### Primary workflow

Services provide a `Routes` tree and project metadata, and the builder outputs a `spec.json` file that drives internal API documentation.

### Business rules

Routes include summaries, request/response examples, and security flags, and error responses are injected from shared error examples.

### Outcomes

Teams can produce consistent OpenAPI specs without duplicating schema generation logic across services.

### Out of scope

Rendering documentation UIs and hosting static API docs are handled by separate tooling.

## Technical Overview

### Architecture flow

`BuildDoc` loads project metadata, builds an OpenAPI document from the route tree, and writes the JSON output to disk.

### Entry points

The main entry points are `BuildDoc` and the `Routes` definition in `apps/micro-services/go-shared/documentbuilder/documentbuilder.go`.

### Key modules

`documentbuilder.go` contains route walking, path parameter extraction, query param mapping, and schema generation logic for request and response examples.

### Data sources and sinks

The builder reads `project.json` and writes `spec.json`, and consumes route metadata supplied by the calling service.

### Integrations and side effects

It integrates with `errs.ErrorExamples` to populate error responses and uses Gin handler presence to determine which routes to include.

### Constraints and risks

Incorrect or missing example data can produce incomplete schemas, and unsupported types may fall back to string types in generated specs.

## Changelog

- 2026-01-30: Initial documentation.
